<template>
  <div
    v-if="$variable('settings.enableKlarna')"
    class="klarna-messaging"
  >
    <klarna-placement
      :id="`klarna-placement-${namespace}`"
      :data-key="key"
      :data-locale="locale"
      :data-purchase-amount="price"
    />
  </div>
</template>

<script>

/**
 * Vue: Klarna messaging (klarna-messaging)
 * -----------------------------------------------------------------------------
 * Component to display Klarna widgets.
 * - Component settings: snippet / dynamic / async / scroll
 *
 * @param {String} namespace - Placement namespace.
 * @param {Number} price - Product, variant, or cart price.
 * @param {Object|Boolean} variant - Canvas formatted variant object.
 *
 */
export default {
  name: 'KlarnaMessaging',

  props: {
    namespace: {
      type: String,
      default: '',
      required: true,
    },
    price: {
      type: Number,
      default: 0,
      required: true,
    },
    variant: {
      type: [Boolean, Object],
      default: false,
    },
  },

  computed: {

    /**
     * Compute placement key.
     * @returns {String}
     */
    key() {
      return 'credit-promotion-auto-size'
    },

    /**
     * Compute locale.
     * @returns {String}
     */
    locale() {
      return `${cnvs.store.language}-${cnvs.store.country}`
    },
  },

  watch: {

    /**
     * Watch price update to refresh placement.
     * @param {Number} newPrice - New price.
     * @param {Number} oldPrice - Old price.
     */
    price(newPrice, oldPrice) {
      if (newPrice === oldPrice) {
        return
      }

      this.refreshPlacement()
    },

    /**
     * Watch variant update to refresh placement.
     */
    variant() {
      this.refreshPlacement()
    },
  },

  mounted() {
    this.refreshPlacement()
  },

  methods: {

    /**
     * Refresh placement.
     */
    async refreshPlacement() {
      if (!window.Klarna?.OnsiteMessaging) {
        return
      }

      await this.$nextTick()
      window.Klarna.OnsiteMessaging.refresh()
    },
  },
}
</script>

<style lang="scss">
@import './klarna-messaging';
</style>
